import actions from '../actions/taskPlans';
import store from 'store';

export const getTaskPlanList = async (queryString) => {
  return actions.getTaskPlanList(queryString);
};

export const deleteTaskPlanList = async (id) => {
  return actions.deleteTaskPlanList(id);
};

export const addTaskPlanList = async (payload, type) => {
  return actions.addTaskPlanList(payload, type);
};

export const getStoreType = async (queryString) => {
  return actions.getStoreType(queryString);
};

export const editTaskPlanList = async (payload, id, type) => {
  return actions.editTaskPlanList(payload, id, type);
};

export const getTaskGroupList = async (queryString) => {
  return actions.getTaskGroupList(queryString);
};

export const editTaskGroupList = async (payload, id, type) => {
  return actions.editTaskGroupList(payload, id, type);
};

export const addTaskGroupList = async (payload) => {
  return actions.addTaskGroupList(payload);
};

export const deleteTaskGroupList = async (id, payload) => {
  return actions.deleteTaskGroupList(id, payload);
};

export const getRoleType = async () => {
  return actions.getRoleType();
};

export const getTaskTemplatesList = async (queryString) => {
  return actions.getTaskTemplatesList(queryString);
};

export const addTaskTemplatesList = async (payload) => {
  return actions.addTaskTemplatesList(payload);
};

export const getTaskPeriodsList = async () => {
  return actions.getTaskPeriodsList();
};

export const deleteTaskTemplatesList = async (id, payload) => {
  return actions.deleteTaskTemplatesList(id, payload);
};

export const editTaskTemplatesList = async (payload, id, type) => {
  return actions.editTaskTemplatesList(payload, id, type);
};